import { gql } from "apollo-boost";

export const BannerInfo = gql`
  query bannerInfo {
    getBannerInfo {
      winterBreakBannerInfo {
        isWinterBreak
        winterBannerTitle
        winterBannerBody
      }
    }
  }
`;
